import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { db } from '../firebase';

const AdminAnalyticsPanel = ({ onClose }) => {
  const [analytics, setAnalytics] = useState({
    totalSignups: 0,
    todaySignups: 0,
    weekSignups: 0,
    monthSignups: 0,
    signupTrend: []
  });
  const [, setLoading] = useState(true);

  useEffect(() => {
    fetchAnalytics();
  }, []);

  const fetchAnalytics = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "signups"), orderBy("timestamp", "desc"));
      const querySnapshot = await getDocs(q);
      
      const signups = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        let timestamp = new Date();
        
        // Handle different timestamp formats
        if (data.timestamp) {
          if (data.timestamp.toDate && typeof data.timestamp.toDate === 'function') {
            timestamp = data.timestamp.toDate();
          } else if (data.timestamp instanceof Date) {
            timestamp = data.timestamp;
          } else if (typeof data.timestamp === 'string') {
            timestamp = new Date(data.timestamp);
          } else if (data.timestamp.seconds) {
            timestamp = new Date(data.timestamp.seconds * 1000);
          }
        }
        
        signups.push({
          timestamp: timestamp,
          email: data.email
        });
      });

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const weekAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
      const monthAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);

      const todaySignups = signups.filter(s => s.timestamp >= today).length;
      const weekSignups = signups.filter(s => s.timestamp >= weekAgo).length;
      const monthSignups = signups.filter(s => s.timestamp >= monthAgo).length;

      // Create signup trend for last 7 days
      const signupTrend = [];
      for (let i = 6; i >= 0; i--) {
        const date = new Date(today.getTime() - i * 24 * 60 * 60 * 1000);
        const nextDate = new Date(date.getTime() + 24 * 60 * 60 * 1000);
        const daySignups = signups.filter(s => 
          s.timestamp >= date && s.timestamp < nextDate
        ).length;
        signupTrend.push({
          date: date.toLocaleDateString('en-US', { weekday: 'short' }),
          day: date.getDate(),
          signups: daySignups
        });
      }

      setAnalytics({
        totalSignups: signups.length,
        todaySignups,
        weekSignups,
        monthSignups,
        signupTrend
      });
    } catch (error) {
      console.error('Error fetching analytics:', error);
    }
    setLoading(false);
  };

  return (
    <div className="admin-analytics-panel">
      <div className="admin-panel-header">
        <h3>Analytics Dashboard</h3>
        <button className="close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="analytics-overview">
        <div className="metric-card">
          <div className="metric-icon">
            <i className="fas fa-users"></i>
          </div>
          <div className="metric-content">
            <div className="metric-number">{analytics.totalSignups}</div>
            <div className="metric-label">Total Signups</div>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-icon">
            <i className="fas fa-calendar-day"></i>
          </div>
          <div className="metric-content">
            <div className="metric-number">{analytics.todaySignups}</div>
            <div className="metric-label">Today</div>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-icon">
            <i className="fas fa-calendar-week"></i>
          </div>
          <div className="metric-content">
            <div className="metric-number">{analytics.weekSignups}</div>
            <div className="metric-label">This Week</div>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-icon">
            <i className="fas fa-calendar-alt"></i>
          </div>
          <div className="metric-content">
            <div className="metric-number">{analytics.monthSignups}</div>
            <div className="metric-label">This Month</div>
          </div>
        </div>
      </div>

      <div className="analytics-chart">
        <h4>Signup Trend (Last 7 Days)</h4>
        <div className="chart-container">
          {analytics.signupTrend.map((day, index) => (
            <div key={index} className="chart-bar">
              <div 
                className="bar"
                style={{ 
                  height: `${Math.max(day.signups * 20, 5)}px`,
                  backgroundColor: day.signups > 0 ? '#6f9283' : '#444'
                }}
              ></div>
              <div className="bar-label">
                <div>{day.date}</div>
                <div className="bar-value">{day.signups}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="analytics-actions">
        <button className="action-btn" onClick={fetchAnalytics}>
          <i className="fas fa-sync-alt"></i>
          Refresh Data
        </button>
        <button className="action-btn" onClick={() => alert('Export detailed analytics report')}>
          <i className="fas fa-download"></i>
          Export Report
        </button>
      </div>
    </div>
  );
};

export default AdminAnalyticsPanel;
